import { isSameDay } from "date-fns";
import { OccupiedDay } from "../api/occupied-days";
import { Reservation } from "../api/reservations";
import { Table } from "../api/tables";

export const throttle = (func: Function, delay = 100, end = false) => {
	let timer: number;
	let lastInvokation: number;

	return function() {
		const context = this;
		const args = arguments;
		const elapsedTime = Date.now() - lastInvokation;

		const invoke = () => {
			func.apply(context, args);
			lastInvokation = Date.now();
		};

		if (!lastInvokation) {
			invoke();
		} else {
			clearTimeout(timer);
			timer = setTimeout(() => {
				if (end || elapsedTime >= delay) {
					invoke();
				}
			}, delay - elapsedTime);
		}
	};
};

export const notEmpty = (v: any) => {
	return v !== null && v !== undefined && v !== "";
};

/**
 * TODO: This function should not be removed
 */
export const fixTime = (time: Date) => {
	if (time !== null && time.toString().substr(0, 4) === "0001") {
		return null;
	}

	return time;
};

export const convertPhoneNumberToLink = (phoneNumber: string) => {
	return `tel:${phoneNumber.replace(/[\s-\(\)\/]/g, "")}`;
};

export const getSelectedOccupiedDay = (
	occupiedDays: OccupiedDay[],
	selectedDate: Date
) => {
	return occupiedDays.filter(day => {
		return isSameDay(day.date, selectedDate);
	})[0];
};

export const getReservationsForDay = (
	reservations: Reservation[],
	selectedDate: Date
) => {
	return reservations.filter(r => isSameDay(r.date, selectedDate));
};

export const getReservationsForTable = (
	tableId: string,
	reservations: Reservation[],
	selectedDate: Date
) => {
	return reservations.filter(
		r => r.tableId === tableId && isSameDay(r.date, selectedDate)
	).sort((a, b) => {
		if (a.time && b.time) {
			return a.time.getTime() - b.time.getTime()
		}

		return -1;
	});
};

export const getPeopleCountSumForTable = (
	tableId: string,
	reservations: Reservation[],
	tableGroups: string[][]
) => {
	let tableGroupIndex = -1;

	if (tableGroups && tableGroups.length > 0) {
		tableGroupIndex = tableGroups.reduce((acc, group, index) => {
			if (group.indexOf(tableId) > -1) {
				acc = index;
			}

			return acc;
		}, -1);
	}

	const activeGroup =
		tableGroupIndex > -1 ? tableGroups[tableGroupIndex] : null;

	return reservations.reduce((acc, reservation) => {
		if (
			(activeGroup !== null &&
				activeGroup.indexOf(reservation.tableId) > -1) ||
			reservation.tableId === tableId
		) {
			acc = acc + reservation.peopleCount;
		}

		return acc;
	}, 0);
};

export const getTotalSoftLimitForTable = (
	id: string,
	tables: Table[],
	tableGroups: string[][]
) => {
	let finalSoftLimit = 0;

	if (tableGroups && tableGroups.length > 0) {
		finalSoftLimit = tableGroups.reduce((acc, group) => {
			if (group.indexOf(id) > -1) {
				acc = group.reduce((a, id) => {
					const table = tables.find(t => t.id === id);

					if (table) {
						a += table.peopleSoftLimit;
					}

					return a;
				}, 0);
			}

			return acc;
		}, 0);
	}

	if (finalSoftLimit === 0) {
		const targetTable = tables.find(t => t.id === id);

		finalSoftLimit = targetTable ? targetTable.peopleSoftLimit : 0;
	}

	return finalSoftLimit;
};

export const isAreaLocked = (areaId: string, occupiedDay: OccupiedDay) => {
	return (
		occupiedDay &&
		occupiedDay.lockedAreas &&
		occupiedDay.lockedAreas.indexOf(areaId) > -1
	);
};

export const coordinatesInAngleRange = (
	x1: number,
	y1: number,
	x2: number,
	y2: number,
	angleRanges: { start?: number; end?: number }[]
) => {
	const angle = (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI + 180;

	for (let i = 0; i < angleRanges.length; i++) {
		if (
			(angleRanges[i].start == null || angle >= angleRanges[i].start) &&
			(angleRanges[i].end == null || angle <= angleRanges[i].end)
		) {
			return true;
		}
	}

	return false;
};

export const nl2br = (str: string) => {
	const r = str.replace(/\n/g, "<br>");

	return r;
};

export const downloadWithFilename = (url: string, filename: string) => {
	const anchor = document.createElement("a");
	anchor.href = url;
	anchor.download = filename;

	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
};
